/* Hold-to-reveal for contact emails/phones. Values arrive reversed + base64 and are
   decoded only after a completed 1.5s hold. No dependencies. */
(function () {
  var HOLD = 1500;

  function decode(v) {
    try { return atob(v).split('').reverse().join(''); } catch (e) { return ''; }
  }

  function telHref(display) {
    var d = display.replace(/[^\d+]/g, '');
    if (d.charAt(0) !== '+') d = (d.length === 10 ? '+1' : '+') + d;
    return 'tel:' + d;
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
    return new Promise(function (resolve, reject) {
      var t = document.createElement('textarea');
      t.value = text; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
      document.body.appendChild(t); t.select();
      try { document.execCommand('copy') ? resolve() : reject(); } catch (e) { reject(e); }
      t.remove();
    });
  }

  function init(root) {
    var btn = root.querySelector('.sc-rc__btn');
    if (!btn || root.dataset.ready) return;
    root.dataset.ready = '1';
    btn.hidden = false;
    var fill = root.querySelector('.sc-rc__fill');
    var label = root.querySelector('.sc-rc__label');
    var idle = label.getAttribute('data-idle');
    var start = 0, raf = 0, done = false;

    function paint(p) { fill.style.transform = 'scaleX(' + p + ')'; }

    function tick(now) {
      var p = Math.min((now - start) / HOLD, 1);
      paint(p);
      if (p >= 1) return reveal();
      raf = requestAnimationFrame(tick);
    }

    function begin() {
      if (done || start) return;
      start = performance.now();
      root.classList.add('is-holding');
      label.textContent = 'Verifying human…';
      raf = requestAnimationFrame(tick);
    }

    function cancel() {
      if (done || !start) return;
      cancelAnimationFrame(raf);
      start = 0;
      root.classList.remove('is-holding');
      label.textContent = idle;
      paint(0);
    }

    function reveal() {
      done = true;
      var type = root.getAttribute('data-type');
      var value = decode(root.getAttribute('data-v'));
      if (!value) return;
      var wrap = document.createElement('span');
      wrap.className = 'sc-rc__revealed';
      var check = document.createElement('span');
      check.className = 'sc-rc__ok';
      check.textContent = '✓ Verified human';
      var row = document.createElement('span');
      row.className = 'sc-rc__row';
      var a = document.createElement('a');
      a.className = 'sc-rc__value';
      a.href = type === 'phone' ? telHref(value) : 'mailto:' + value;
      a.textContent = value;
      var copy = document.createElement('button');
      copy.type = 'button';
      copy.className = 'sc-rc__copy';
      copy.textContent = 'Copy';
      copy.addEventListener('click', function () {
        copyText(value).then(function () {
          copy.textContent = 'Copied!';
          setTimeout(function () { copy.textContent = 'Copy'; }, 2000);
        }, function () { copy.textContent = 'Copy failed'; });
      });
      row.appendChild(a); row.appendChild(copy);
      wrap.appendChild(check); wrap.appendChild(row);
      var idleEl = root.querySelector('.sc-rc__idle');
      var hadFocus = document.activeElement === btn;
      idleEl.replaceWith(wrap);
      root.classList.remove('is-holding');
      root.classList.add('is-revealed');
      root.querySelector('.sc-rc__live').textContent = (type === 'phone' ? 'Phone: ' : 'Email: ') + value;
      if (hadFocus) a.focus({ preventScroll: true });
    }

    btn.addEventListener('pointerdown', function (e) {
      if (e.button !== 0) return;
      e.preventDefault();
      btn.focus({ preventScroll: true });
      begin();
    });
    ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (ev) { btn.addEventListener(ev, cancel); });
    btn.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    btn.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); if (!e.repeat) begin(); }
    });
    btn.addEventListener('keyup', function (e) { if (e.key === ' ' || e.key === 'Enter') cancel(); });
    btn.addEventListener('blur', cancel);
  }

  function boot() { document.querySelectorAll('[data-sc-contact-reveal]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
